var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowDown_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.7 13.24a.987.987 0 0 0-1.41.02l-4.23 4.32V3.97c0-.55-.45-1-1-1s-1 .45-1 1V17.6l-4.34-4.39a.987.987 0 0 0-1.41 0 .987.987 0 0 0 0 1.41l6.05 6.11a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l5.95-6.08a.987.987 0 0 0-.02-1.41z"
})));
export default SvgArrowDown;